<template>
    <router-link :to="routerLink">
        <div class="card">
          <div class="card-content">
            <div class="media">
              <div class="media-left">
                <figure class="image is-48x48">
                  <img class='is-rounded' :src="user.image[0].sizes.circularList" alt="User profile picture">
                </figure>
              </div>
              <div class="media-content">
                <p class="title is-5">{{user.firstName}} {{user.lastName}}</p>
                <!-- <p class="subtitle is-6"><small>Computer Science 2017</small></p> -->
              </div>
            </div>
          </div>
        </div>
    </router-link>
</template>

<style scoped>
.card {
    box-sizing: border-box;
    width: 30%;
    margin: 5px 5px auto;
    float: left;
}
.card-content { padding: 0.8rem; }
</style>

<script>
export default {
  name: 'UserTile',
  data () {
    return {
      routerLink: ''
    }
  },
  mounted: function() {
    this.routerLink = '/user/' + this.$props.user.username;
  },
  props: ['user']
}
</script>



// WEBPACK FOOTER //
// src/components/UserTile.vue